import { CREATE_TAG, LIST_TERRITORY_TAGS_PAGINATED, UPDATE_TAGS_STATE } from './operations'
import type { TagsMutationsMap, TagsQueriesMap } from './types'

export const GRAPHQL_TAGS_QUERIES: TagsQueriesMap = {
  listTerritoryTagsPaginated: LIST_TERRITORY_TAGS_PAGINATED,
}

export const GRAPHQL_TAGS_MUTATIONS: TagsMutationsMap = {
  createTag: CREATE_TAG,
  updateTagsState: UPDATE_TAGS_STATE,
}
